export default "__VITE_ASSET__CnILIFBi__"